<section
  class="stream-wrapper"
  [ngClass]="{'action-buttons-enabled': buttons && buttons.length}">
  <ul class="stream-wrapper__action-buttons"
    *ngIf="buttons && buttons.length">
    <li *ngFor="let b of buttons">
      <a
        *ngIf="b.type === 'delete'"
        [title]="b.title || 'Remove stream'"
        (click)="buttonClickEvent('delete')">
        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"/></svg>
      </a>
    </li>
  </ul>
  <a class="stream-wrapper__thumbnail"
    *ngIf="stream.iconImageUrl || stream.iconImageThbs"
    [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]"
    [title]="'Visit ' + stream.name">
    <picture>
      <source
        *ngFor="let item of stream.iconImageThbs | keyvalue"
        [media]="'(min-width: ' + item.key + 'px)'"
        [srcset]="item.value">
      <img [src]="stream.iconImageUrl" />
    </picture>
  </a>
  <div class="stream-wrapper__details">
    <h2 class="stream-wrapper__details__title">
      <a class="stream-wrapper__details__title__link"
        [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]" [title]="stream.name">{{stream.name}}</a>
    </h2>
    <span class="stream-wrapper__details__subs">{{stream.numSubs}} Subscribers</span>
    <div class="stream-wrapper__details__description">
      {{streamDescriptionLimited || stream.description}}
    </div>
  </div>
  <div class="stream-wrapper__ream-more">
    <a
      class="stream-wrapper__ream-more__button notd__button--v2"
      [routerLink]="stream.shortURLPath ? ['/s', stream.shortURLPath] : ['/streams', stream.id, 'view', stream.indexedName || stream.name || stream.id]"
      [title]="'Show stream ' + stream.name + ' details'">See more</a>
  </div>
</section>
